import React from 'react';
import TermsAndConditions from './TermsAndConditions';

type LoginOpionsProps = { children: React.ReactNode };

const LoginOpions = ({ children }: LoginOpionsProps) => {
	return (
		<div className="vtex-login-2-x-content content vtex-login-2-x-content--loginOptions content--loginOptions flex relative bg-base justify-around overflow-visible pa4 center items-baseline-ns items-baseline vtex-login-2-x-contentInitialScreen contentInitialScreen">
			<div className="vtex-login-2-x-contentForm contentForm dn vtex-login-2-x-contentFormVisible contentFormVisible db">
				<div className="vtex-login-2-x-loginOptionsContainer loginOptionsContainer">
					<div className="vtex-login-2-x-options options">{children}</div>
					<TermsAndConditions />
				</div>
			</div>
		</div>
	);
};

export default LoginOpions;
